/*
 * Nav menu click tracking.
 *
 * Every nav item in the desktop dropdown menu and the mobile drawer
 * carries data-nav-level (1-3), data-nav-action ("navigate" for real
 * links, "open" for parent items that only expand a submenu), and one
 * data-nav-t1/t2/t3 attribute per level of its own ancestry, each
 * holding a single unmodified menu title ("All Fabrics", then
 * "by Season / Holiday").
 *
 * The titles are kept in separate attributes rather than in one
 * delimited string on purpose: a menu title may itself contain the
 * " / " separator, which makes a joined path impossible to split back
 * into levels. Paths are built here and never parsed — so a title
 * containing any delimiter stays intact.
 *
 * This listener pushes one dataLayer event per click for GTM to
 * forward to GA4. Capture phase so the push happens before navigation
 * starts; GA4's beacon transport survives the page unload.
 *
 * Roll-up attribution: nav_l1/nav_l2/nav_l3 carry the click's
 * ancestor paths, so a level-3 click also counts toward its level-1
 * and level-2 ancestors when a report groups by those params —
 * deeper clicks attribute upward without extra events.
 */
(function () {
  document.addEventListener(
    'click',
    function (event) {
      var item = event.target.closest('[data-nav-t1]');
      if (!item) return;

      var titles = [item.dataset.navT1, item.dataset.navT2, item.dataset.navT3].filter(Boolean);

      function pathTo(depth) {
        return titles.slice(0, depth).join(' / ');
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'nav_click',
        nav_level: Number(item.dataset.navLevel),
        nav_action: item.dataset.navAction,
        nav_path: pathTo(titles.length),
        nav_item: titles[titles.length - 1],
        nav_l1: titles[0],
        nav_l2: titles.length > 1 ? pathTo(2) : undefined,
        nav_l3: titles.length > 2 ? pathTo(3) : undefined,
        nav_menu: item.closest('.menu-drawer') ? 'drawer' : 'desktop',
      });
    },
    { capture: true }
  );
})();
